import { number, object, string } from 'yup'

import { RequestStandardBilling, PolicyRule } from 'src/types'

type GetValidationSchemaProps = {
  policyRule: PolicyRule
}

function getInitialValues(): RequestStandardBilling {
  return {
    active: true,
    request_id: null,
    billing_reference_type: 'COST_CENTER',
    billing_type_id: null,
    observation: '',
    request_standard_billing_id: null,
    request_standard_billing_number: null,
    target_id: null
  }
}

function getValidationSchema({ policyRule }: GetValidationSchemaProps) {
  return object().shape({
    billing_reference_type: string()
      .when('active', {
        is: true,
        then: string().required('common.required')
      })
      .typeError('common.required'),
    billing_type_id: number()
      .when('active', {
        is: true,
        then: number().required('common.required')
      })
      .typeError('common.required'),
    target_id: number()
      .when('active', {
        is: true,
        then: number().required('common.required').typeError('common.required')
      })
      .typeError('common.required'),
    observation: string().when('active', {
      is: active => active && policyRule?.enable_billing_observation,
      then: string().required('common.required'),
      otherwise: string().notRequired()
    })
  })
}

export { getInitialValues, getValidationSchema }
